import Api from '../library/Api';
import {
	DELETE_USER_URL,
	RECAPTCHA_URL,
	SIGN_IN_URL,
	SIGN_UP_URL,
} from './Urls';

export const signUpUserApi = data =>
	Api.request({
		method: 'post',
		url: SIGN_UP_URL,
		body: data,
	});

export const signInUserApi = data =>
	Api.request({
		method: 'post',
		url: SIGN_IN_URL,
		body: data,
	});

export const deleteUserApi = id =>
	Api.request({
		method: 'delete',
		url: DELETE_USER_URL + `/${id}`,
	});

export const verfiyHuman = data =>
	Api.request({
		method: 'post',
		url: RECAPTCHA_URL,
		body: data,
	});
